import React, { Component, Fragment } from 'react'
import { Input, Button } from 'loyal-react'
import PropTypes from 'prop-types'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

const ShippingValueLabel = ({ onlyCash, shippingValue, currencyText }) => {
  let shippingValueText = ''
  if (onlyCash) {
    shippingValueText = `${currencyText} ${numberToStrCurrency(shippingValue, 2)}`
  } else {
    shippingValueText = `${shippingValue}`
  }
  if (shippingValue === 0) {
    return <span className='txt-bold color-success'>Grátis</span>
  } else {
    return (
      <Fragment>
        {shippingValueText}
      </Fragment>
    )
  }
}

class Shipping extends Component {
  constructor (props) {
    super(props)

    this.state = {
      codeShipping: '',
      msgShipping: ''
    }
  }

  SendShipping () {
    if (this.ValidateShipping()) {
      this.props.fetchShipping(this.state.codeShipping, this.props.productSkuId)
    } else {
      this.props.errorFilledShipping()
    }
  }

  ValidateShipping () {
    if (this.state.codeShipping) {
      return true
    }
    return false
  }

  GetShippingValueFromContext () {
    if (this.props.onlyCash) {
      return this.props.value.shippingValueCash
    } else {
      return this.props.value.shippingValue
    }
  }

  SetInputMessage () {
    if (this.props.error !== undefined) return false
    else return null
  }
  showMessage () {
    setTimeout(() => {
      this.setState({
        msgShipping: 'Frete Calculado'
      })
    }, 300)
  }
  backStateShipping () {
    this.props.backStateShipping()
    setTimeout(() => {
      document.querySelector(`#cep`).focus()
    }, 300)
  }
  renderAddress () {
    return (
      <div className='shipping-form row row-eq-height pt-2 '>
        <div
          className='hide-absolute'
          role='status'
          aria-live='assertive'
          aria-atomic='true'
        >
          {this.state.msgShipping}
        </div>
        <div className='shipping-input col-12 form-field pr-half'>
          <div className='row align-items-center h-100'>
            <div className='col-12'>
              <p className='txt-body-sm'>{this.props.value.adress}</p>
              <p className='txt-body-sm'>{this.props.value.district}</p>
              <p className='txt-body-sm'>{this.props.value.city}</p>
              <p className='txt-body-sm'>{this.state.codeShipping}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderUpdateShipping () {
    this.showMessage()
    return (
      <div className='shipping-form row row-eq-height pt-2 '>
        <div className='col-12 col-md-12 border-top border-color-ui-4 mt-2 pt-2'>
          <div className='row'>
            <div className='col-4'>
              <p>
                <strong>Frete</strong>
                <br />
                <span className='txt-body-sm txt-initial'>
                  <ShippingValueLabel
                    onlyCash={this.props.onlyCash}
                    shippingValue={this.GetShippingValueFromContext()}
                    currencyText={this.props.onlyCash ? 'R$' : this.props.pointsName} />
                </span>
              </p>
            </div>
            <div className='col-4'>
              <p>
                <strong>Prazo</strong>
                <br />
                <span className='txt-body-sm'>
                  {this.props.value.deliveryForeCastDate}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFetchShipping () {
    return (
      <div className='shipping-form row row-eq-height pt-2'>
        {!this.props.filled ? (
          <Input
            id='cep'
            label='CEP'
            className='shipping-input col-6 col-md-5 pr-half'
            onChange={e => {
              this.setState({
                codeShipping: e.target.value.replace('-', '').replace('.', '')
              })
            }}
            data-error={'Não é possível entregar no CEP digitado.'}
            mask={[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
            valid={this.SetInputMessage()}
            value={this.state.codeShipping}
          />
        ) : (
          <div className='col'>{this.renderAddress()}</div>
        )}
        <div className='shipping-button col-6 col-md-4 form-field pl-half'>
          <Button
            id={'SendShipping'}
            name={'SendShipping'}
            className='btn btn-sm'
            text={!this.props.filled ? 'Calcular' : 'Alterar'}
            onClick={() =>
              !this.props.filled
                ? this.SendShipping()
                : this.backStateShipping()
            }
            loading={this.props.isloading}
          />
        </div>
        {!this.props.filled && (
          <div className='shipping-input col-12 col-md-3 form-field'>
            <div className='row align-items-center h-100 p-0 mt-1 mt-md-0'>
              <a
                href='http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm'
                target='_blank'
                className=' color-brand-2 txt-underline txt-body-sm txt-font-body txt-left mx-1'
                title='Ir para o site do Correios'
              >
                Procurar CEP
              </a>
            </div>
          </div>
        )}
      </div>
    )
  }

  render () {
    return (
      <div
        className={`product-shipping col-12 py-2 px-3 mx-0 ${
          this.props.isVoucher === false ? 'd-block' : 'd-none'
        }`}
      >
        <h3 className='txt-info-product txt-body txt-font-body color-brand-1 txt-uppercase mb-1'>
          Frete e prazo de entrega
        </h3>
        {!this.props.filled && (
          <p className='txt-body-sm'>
            Calcule o valor do seu frete e saiba o prazo de entrega.
          </p>
        )}
        {this.renderFetchShipping()}
        {this.props.filled && this.renderUpdateShipping()}
      </div>
    )
  }
}

Shipping.propTypes = {
  productSkuId: PropTypes.string,
  filled: PropTypes.bool,
  fetchShipping: PropTypes.func,
  backStateShipping: PropTypes.func,
  errorFilledShipping: PropTypes.func,
  error: PropTypes.string,
  value: PropTypes.object,
  isloading: PropTypes.bool,
  isVoucher: PropTypes.bool,
  pointsName: PropTypes.string,
  onlyCash: PropTypes.bool
}

export default Shipping



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/Shipping/Shipping.js